import React, { FC } from "react";
import styled from "@emotion/styled";
import { UpOutlined } from "@ant-design/icons";
import TabelData from "./TableData";
import { useGetReportTopSale } from "hooks/useDashboard";
import ChartProduct from "./ChartProduct";

interface TableTopProductProps {
    selectPeriod: string;
    daterangePicker: [string, string]
}

const TableTopProduct:FC<TableTopProductProps> = ({selectPeriod, daterangePicker}) => {
    const { data, isLoading } = useGetReportTopSale({ period: selectPeriod, start_date: daterangePicker[0], end_date: daterangePicker[1] });
    return (
    <CardWrapper>
      
      <CardHeaderWrapper>
        <WrapperTextHeader>5 สินค้าขายดี</WrapperTextHeader>
        {/* <RightSelect setSelectYear={setSelectYear} /> */}
      </CardHeaderWrapper>
      <RowPercentWrapper>
        {/* <WrapperTextPercent>
          <TextPositive>Top 5 Product</TextPositive>
        </WrapperTextPercent> */}
      </RowPercentWrapper>
      {/* <WrapperTextContent>
        <TextAmount>฿280,000</TextAmount>
        <TextPercent>+10.6%</TextPercent>
      </WrapperTextContent> */}
     <ChartProduct data={data?.data} isLoading={isLoading} />
    </CardWrapper>
  );
};

export default TableTopProduct;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 20px 20px 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`;

const CardHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const RowPercentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const TextPositive = styled.p`
  font-size: 14px;
  font-weight: 400;
`;

const WrapperIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  height: 19px;
`;

const WrapperTextPercent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 19px;
`;

const WrapperTextHeader = styled.p`
  font-size: 18px;
  font-weight: 400;
`;

const TextAmount = styled.p`
  font-size: 18px;
  font-weight: 500;
  background-color: #ffffff;
`;

const TextPercent = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #00b300;
  margin-left: 5px;
`;

const WrapperTextContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: auto;
  border-radius: 0px;
  padding: 0px 0px 0px 0px;
`;
